<template>
  <div class="ap-field-input-wrapper">
    <div class="title-field">{{validator.name}}</div>
    <div class="ap-input-wrapper" v-if="validator.name !== 'Email' && validator.name !== 'Phone' && validator.name !== 'Card Code'">
      <!--{ "id": 9, "name": "First Name", "field": "first_name", "createdAt": "2019-10-30T02:52:34.065814Z", "lastModifiedAt": "2019-10-30T02:52:34.065814Z", "type": "text", "description": "First Name", "values": null, "frontEndField": "firstName" }-->
      <input :type="validator.type" v-model="participant[validator.frontEndField]" v-validate="'required'" :data-vv-as="validator.name" :name="validator.frontEndField" class="input field-input" @blur="blurFunc()">
    </div>
    <div class="error-message" v-if="validator.name !== 'Email' && validator.name !== 'Phone' && validator.name !== 'Card Code'">{{ errors.first(validator.frontEndField) }}</div>

    <div class="ap-input-wrapper" v-if="validator.name === 'Email'">
      <input type="text" v-model="participant[validator.frontEndField]" class="input field-input" v-validate="'required|email'" data-vv-as="email" :name="validator.frontEndField" placeholder="sample@email.com" @blur="blurFunc()">
    </div>
    <div class="error-message" v-if="validator.name === 'Email'">{{ errors.first(validator.frontEndField) }}</div>

    <div class="ap-input-wrapper" v-if="validator.name === 'Card Code'">
      <input :type="validator.type" v-model="participant[validator.frontEndField]" v-validate="" :data-vv-as="validator.name" :name="validator.frontEndField" class="input field-input" @blur="blurFunc()">
    </div>

    <div class="error-message" v-if="validator.name === 'Email'">{{ errors.first(validator.frontEndField) }}</div>
    <div class="ap-input-wrapper" v-if="validator.name === 'Phone'">
      <input class="input field-input" v-the-mask="'+1(###)-###-####'"
             v-validate="'required'" name="phone"
             type="text" placeholder="+1(###)-###-####" v-model="participant[validator.frontEndField]"
             @blur="blurFunc()">
    </div>
    <div class="error-message" v-if="validator.name === 'Phone'">{{ errors.first(validator.frontEndField) }}</div>
  </div>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import { mask } from 'vue-the-mask';
  // import constant from '../../_consts';

  export default {
    name: 'validator-field',
    components: {
    },
    props: {
      validator: {},
      participant: {}
    },
    data () {
      return {
        firstName: ''
      }
    },
    directives: { 'the-mask': mask },
    methods: {
      blurFunc () {
        this.$validator.validate().then(result => {
          if (!result) {
            this.participant.isValid = false;
            this.$emit('clicked', this.participant);
            return;
          }
          this.participant.isValid = true;
          this.$emit('clicked', this.participant)
        });
      },
      validateData () {
        return new Promise(resolve => {
          this.$validator.validate().then(valid => {
            resolve(valid);
          });
        });
      },
      ...mapActions({
      }),
      ...mapMutations({
      })
    },
    computed: {
      ...mapGetters({
      })
    }
  }
</script>

<style lang="less" scoped>
  @import '../../styles/variables.less';
</style>



// WEBPACK FOOTER //
// ValidatorField.vue?f0bf8ebc